// MUI-name → FightDecks icon aliases. Lets every `@mui/icons-material` import be
// swapped to `components/icons` by changing only the source path — the imported
// name still resolves. Long-tail/one-off icons map to the closest Bare Knuckle
// icon; Eric refines specific ones later. Marketplace glyphs ($/cart/tag/store)
// intentionally map to a NEUTRAL card icon — no marketplace iconography is drawn
// (and that code is launch-disabled anyway).
import {
  BinderIcon, CardIcon, CardStackIcon, CardAddIcon, ChecklistIcon, ParallelsIcon,
  CompletionIcon, BeltIcon, FistIcon, SignatureIcon, RookieIcon, CameraIcon,
  UploadIcon, StatsIcon, CalendarIcon,
} from './featureIcons';
import {
  SearchIcon, FilterIcon, SortIcon, ProfileIcon, SettingsIcon, BellIcon, EditIcon,
  TrashIcon, CloseIcon, CheckIcon, ChevronDownIcon, ChevronUpIcon, ChevronLeftIcon,
  ChevronRightIcon, ArrowLeftIcon, ArrowRightIcon, ShareIcon, MoreIcon, FavoriteIcon,
  StarIcon, VisibilityIcon, VisibilityOffIcon, LocationIcon, MessageIcon, EmailIcon,
  LockIcon, RefreshIcon, SendIcon, GroupIcon, LogoutIcon, InfoIcon, WarningIcon,
  ErrorIcon, AddIcon, RemoveIcon, DownloadIcon, CheckCircleIcon,
} from './utilityIcons';
import {
  HomeIcon, MenuIcon, SaveIcon, LinkIcon, PhoneIcon, BookmarkIcon, PlayIcon,
  StopIcon, LanguageIcon, CopyIcon, ImageIcon, FolderIcon, SwapIcon, DeviceIcon,
} from './extraIcons';

// Cards / collecting
export const Collections = CardStackIcon;
export const Style = CardStackIcon;
export const ViewModule = CardStackIcon;
export const ViewList = CardStackIcon;
export const GridView = CardStackIcon;
export const Inventory = CardStackIcon;
export const Category = CardStackIcon;
export const AddBox = CardAddIcon;
export const AddCard = CardAddIcon;
export const FactCheck = ChecklistIcon;
export const DoneAll = ChecklistIcon;
export const Looks = ParallelsIcon;
export const Palette = ParallelsIcon;
export const DonutLarge = CompletionIcon;
export const DataUsage = CompletionIcon;
export const EmojiEvents = BeltIcon;
export const WorkspacePremium = BeltIcon;
export const SportsMma = FistIcon;
export const SportsKabaddi = FistIcon;
export const SportsMartialArts = FistIcon;
export const FitnessCenter = FistIcon;
export const LocalFireDepartment = FistIcon;
export const AutoFixHigh = SignatureIcon;
export const NewReleases = RookieIcon;
export const Shield = RookieIcon;
export const MenuBook = BinderIcon;
export const AutoStories = BinderIcon;
export const Dashboard = BinderIcon;
export const Home = HomeIcon;
export const PhotoCamera = CameraIcon;
export const CameraAlt = CameraIcon;
export const CameraEnhance = CameraIcon;
export const FlipCameraIos = CameraIcon;
export const FlipCameraAndroid = CameraIcon;
export const Crop = CameraIcon;
export const Photo = ImageIcon;
export const Image = ImageIcon;
export const PhotoLibrary = ImageIcon;
export const CloudUpload = UploadIcon;
export const Upload = UploadIcon;
export const BarChart = StatsIcon;
export const Analytics = StatsIcon;
export const Assessment = StatsIcon;
export const Timeline = StatsIcon;
export const TrendingUp = StatsIcon;
export const TrendingDown = StatsIcon;
export const Storage = StatsIcon;
export const Height = StatsIcon;
export const MonitorWeight = StatsIcon;
export const Straighten = StatsIcon;
export const Event = CalendarIcon;
export const CalendarToday = CalendarIcon;
export const DateRange = CalendarIcon;
export const Schedule = CalendarIcon;
export const AccessTime = CalendarIcon;
export const History = CalendarIcon;
export const Update = RefreshIcon;
export const PendingActions = CalendarIcon;
export const Cake = CalendarIcon;

// Utility
export const Search = SearchIcon;
export const ZoomIn = SearchIcon;
export const ZoomOut = SearchIcon;
export const FilterList = FilterIcon;
export const Sort = SortIcon;
export const SelectAll = SortIcon;
export const Person = ProfileIcon;
export const AccountCircle = ProfileIcon;
export const InsertEmoticon = ProfileIcon;
export const EmojiEmotions = ProfileIcon;
export const PersonRemove = ProfileIcon;
export const Settings = SettingsIcon;
export const AdminPanelSettings = SettingsIcon;
export const Construction = SettingsIcon;
export const Notifications = BellIcon;
export const NotificationsNone = BellIcon;
export const Edit = EditIcon;
export const TextFields = EditIcon;
export const Delete = TrashIcon;
export const Close = CloseIcon;
export const Cancel = CloseIcon;
export const Clear = CloseIcon;
export const Block = CloseIcon;
export const X = CloseIcon;
export const Check = CheckIcon;
export const CheckCircle = CheckCircleIcon;
export const CheckCircleOutline = CheckCircleIcon;
export const Verified = CheckCircleIcon;
export const ExpandMore = ChevronDownIcon;
export const ExpandLess = ChevronUpIcon;
export const ArrowBackIosNew = ChevronLeftIcon;
export const ArrowForwardIos = ChevronRightIcon;
export const ArrowBack = ArrowLeftIcon;
export const Reply = ArrowLeftIcon;
export const ArrowForward = ArrowRightIcon;
export const ArrowCircleRight = ArrowRightIcon;
export const Share = ShareIcon;
export const MoreVert = MoreIcon;
export const Circle = MoreIcon;
export const Favorite = FavoriteIcon;
export const FavoriteBorder = FavoriteIcon;
export const Visibility = VisibilityIcon;
export const VisibilityOff = VisibilityOffIcon;
export const LocationOn = LocationIcon;
export const Message = MessageIcon;
export const ChatBubble = MessageIcon;
export const MarkChatRead = MessageIcon;
export const MarkChatUnread = MessageIcon;
export const Email = EmailIcon;
export const Lock = LockIcon;
export const Security = LockIcon;
export const Refresh = RefreshIcon;
export const RotateLeft = RefreshIcon;
export const RotateRight = RefreshIcon;
export const SwapHoriz = SwapIcon;
export const Send = SendIcon;
export const Group = GroupIcon;
export const People = GroupIcon;
export const PersonAdd = GroupIcon;
export const PersonAddAlt = GroupIcon;
export const ExitToApp = LogoutIcon;
export const Info = InfoIcon;
export const Help = InfoIcon;
export const Warning = WarningIcon;
export const PriorityHigh = WarningIcon;
export const Report = WarningIcon;
export const BugReport = WarningIcon;
export const Error = ErrorIcon;
export const ErrorOutline = ErrorIcon;
export const Add = AddIcon;
export const Remove = RemoveIcon;
export const Download = DownloadIcon;
export const Save = SaveIcon;
export const Star = StarIcon;
export const StarBorder = StarIcon;
export const AutoAwesome = StarIcon;
export const Tips = StarIcon;
export const AttachFile = LinkIcon;
export const Link = LinkIcon;
export const Menu = MenuIcon;
export const Language = LanguageIcon;
export const Phone = PhoneIcon;
export const Smartphone = PhoneIcon;
export const Computer = DeviceIcon;
export const Tablet = DeviceIcon;
export const ContentCopy = CopyIcon;
export const Bookmark = BookmarkIcon;
export const BookmarkBorder = BookmarkIcon;
export const BookmarkRemove = BookmarkIcon;
export const PlayArrow = PlayIcon;
export const Stop = StopIcon;
export const Archive = FolderIcon;
export const Unarchive = FolderIcon;
export const Folder = FolderIcon;
export const FolderOpen = FolderIcon;
export const Work = FolderIcon;
export const WorkOutline = FolderIcon;
export const Description = CardIcon;
export const Notes = CardIcon;
export const Extension = CardIcon;

// Social — neutral share/link stand-ins (brand marks refined later).
export const Instagram = ShareIcon;
export const Twitter = ShareIcon;
export const YouTube = ShareIcon;
export const Facebook = ShareIcon;
export const FacebookOutlined = ShareIcon;

// Marketplace — launch-disabled; NEUTRAL card icon (no marketplace iconography).
export const Sell = CardIcon;
export const Store = CardIcon;
export const Storefront = CardIcon;
export const ShoppingCart = CardIcon;
export const LocalOffer = CardIcon;
export const LocalShipping = CardIcon;
export const AttachMoney = CardIcon;
export const MonetizationOn = CardIcon;
export const CreditCard = CardIcon;
